import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Cross from '../statics/ico/cross__red.svg';

const InputStyle = styled.label`
  display: flex;
  flex-direction: column;

  .label {
    margin-bottom: 7px;
    font-weight: 700;
    color: ${({ theme }) => theme.grey700};
    font-size: 12px;

    &.empty {
      margin-top: 12px;
    }
  }

  input {
    color: ${({ theme }) => theme.grey500};
    border: 1px solid ${({ theme }) => theme.grey300};
    padding: 5px 20px 5px 10px;
    font-size: 14px;
    border-radius: 5px;
    transition: ${({ theme }) => theme.transition};
    width: 100%;

    &::-webkit-calendar-picker-indicator {
      display: none;
    }

    &[type='date']::-webkit-input-placeholder {
      visibility: hidden !important;
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: none;
      margin: 0;
    }

    &:focus {
      border-color: ${({ theme }) => theme.blue500};
      outline: 0;
    }

    &:disabled {
      opacity: 0.4;
    }

    &::placeholder {
      color: ${({ theme }) => theme.grey100};
    }
  }

  .inputContainer {
    display: inline-block;
    width: 100%;
  }

  .withError {
    .inputContainer {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 8px;
        background: url(${Cross}) no-repeat center center / contain transparent;
      }
    }

    input {
      border-color: ${({ theme }) => theme.red600};
    }
  }

  .error {
    font-size: 11px;
    color: ${({ theme }) => theme.red900};
    margin-top: 5px;
    display: block;
  }
`;

const Input = ({ name, label, error, className, ...props }) => (
  <InputStyle htmlFor={name} className={className}>
    <span className={`label ${!label ? 'empty' : ''}`}>{label || null}</span>
    <div className={error ? 'withError' : ''}>
      <div className="inputContainer">
        <input id={name} name={name} {...props} />
      </div>
    </div>
    {error && <span className="error">{error}</span>}
  </InputStyle>
);

Input.defaultProps = {
  onChange: () => {},
  error: null,
  label: null,
  className: null,
};

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  error: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default Input;
